var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { onclick: "event.preventDefault();" } },
    [
      _c(
        "span",
        {
          staticClass: "link text-primary",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.displayForm.apply(null, arguments)
            }
          }
        },
        [
          _c("i", { staticClass: "fas fa-cogs" }),
          _vm._v(" \n        Configurações")
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Configurações", size: "lg" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "float-right",
                          attrs: { variant: "danger", size: "sm" },
                          on: { click: _vm.displayForm }
                        },
                        [_vm._v("Fechar")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalpassword,
            callback: function($$v) {
              _vm.modalpassword = $$v
            },
            expression: "modalpassword"
          }
        },
        [
          _c(
            "b-card",
            { staticClass: "p-4 mb-3", attrs: { "no-body": "" } },
            [
              _c(
                "b-row",
                { staticClass: "text-center" },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center" },
                    [
                      _c("b-avatar", {
                        attrs: { size: "150px", src: _vm.file.avatar }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass: "text-center mt-2 mb-3",
                  attrs: { "align-h": "center" }
                },
                [
                  _c(
                    "b-col",
                    { staticClass: "col-md-10" },
                    [
                      _vm.file.avatar
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mt-1",
                              attrs: { variant: "danger", size: "sm" },
                              on: {
                                click: function($event) {
                                  return _vm.removeImage("avatar")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        Remover Imagem\n                    "
                              )
                            ]
                          )
                        : _c("b-form-file", {
                            attrs: {
                              placeholder: "Adicionar Imagem",
                              "no-drop": "",
                              accept: ".jpg, .png, .jpeg",
                              "browse-text": "Procurar"
                            },
                            on: {
                              change: function($event) {
                                return _vm.onFileChange($event, "avatar")
                              }
                            },
                            model: {
                              value: _vm.imagem,
                              callback: function($$v) {
                                _vm.imagem = $$v
                              },
                              expression: "imagem"
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm.isDistribuidor
                ? _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _c("i", { staticClass: "fab fa-whatsapp" }),
                            _vm._v(" WhatsApp")
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: ["(##) ####-####", "(##) #####-####"],
                                expression:
                                  "['(##) ####-####', '(##) #####-####']"
                              }
                            ],
                            attrs: { id: "telefone1", placeholder: "Numero" },
                            model: {
                              value: _vm.whatsapp,
                              callback: function($$v) {
                                _vm.whatsapp = $$v
                              },
                              expression: "whatsapp"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "input-group-1",
                            label: "Nova Senha",
                            "label-for": "password"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "password",
                              type: "password",
                              required: "",
                              state: _vm.validation
                            },
                            model: {
                              value: _vm.password,
                              callback: function($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            { attrs: { state: _vm.validation } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.passwordError) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-valid-feedback",
                            { attrs: { state: _vm.validation } },
                            [
                              _vm._v(
                                "\n                            Senha Válida\n                        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "input-group-1",
                            label: "Confirme a Senha",
                            "label-for": "confirm"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "confirm",
                              type: "password",
                              required: "",
                              state: _vm.validationConfirm
                            },
                            model: {
                              value: _vm.confirm_password,
                              callback: function($$v) {
                                _vm.confirm_password = $$v
                              },
                              expression: "confirm_password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "input-group-1",
                            label: "E-mail",
                            "label-for": "mail"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "mail",
                              type: "email",
                              required: "",
                              state: _vm.validateEmail
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isDistribuidorClass === "P"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "input-group-1",
                                label: "Nome Fantasia",
                                "label-for": "mail"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "nome_fantasia",
                                  type: "text",
                                  required: "",
                                  state: _vm.validateNomeFantasia,
                                  placeholder: "Nome Fantasia"
                                },
                                model: {
                                  value: _vm.nome_fantasia,
                                  callback: function($$v) {
                                    _vm.nome_fantasia = $$v
                                  },
                                  expression: "nome_fantasia"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3 justify-content-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.save }
                    },
                    [_vm._v("Salvar")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center mb-2", attrs: { cols: "12" } },
                    [_c("h5", [_vm._v("Favoritos (Barra de Navegação)")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mb-3 d-flex", attrs: { cols: "12" } },
                    [
                      _c("b-select", {
                        attrs: { disabled: _vm.maxItems, options: _vm.menus },
                        model: {
                          value: _vm.selected,
                          callback: function($$v) {
                            _vm.selected = $$v
                          },
                          expression: "selected"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mx-2",
                          attrs: { disabled: _vm.maxItems },
                          on: { click: _vm.addFavoritos }
                        },
                        [_c("i", { staticClass: "fas fa-plus" })]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "overflow-auto",
                      staticStyle: { "max-height": "129px" },
                      attrs: { cols: "12" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex justify-content-center flex-wrap"
                        },
                        _vm._l(_vm.favoritos, function(select, index) {
                          return _c(
                            "b-form-tag",
                            {
                              key: index,
                              staticClass: "m-1",
                              attrs: { title: select.label },
                              on: {
                                remove: function($event) {
                                  return _vm.removeTag(index)
                                }
                              }
                            },
                            [_vm._v(_vm._s(index + " - " + select.label))]
                          )
                        }),
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-3 text-right", attrs: { cols: "12" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "float-right",
                          attrs: { variant: "primary" },
                          on: { click: _vm.saveFavorites }
                        },
                        [_vm._v("Salvar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04f7d4be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f7d4be","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/Password.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-04f7d4be","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/Password.vue
// module chunks = 2